<template>
  <div class="w-full bg-[#FFF] pb-[100px] px-4">
    <div class="w-full max-w-[1064px] mx-auto">
      <p
        class="poppins font-normal text-[#F44F1A] text-[48.8px] lg:text-[70px] -tracking-widest mb-8"
      >
        <span class="underline">WORK</span>
        PROJECT
      </p>
      <div
        class="poppins grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 h-full max-h-[500px] lg:max-h-none overflow-y-auto"
      >
        <div
          v-for="(project, index) in dataProjects"
          :key="index"
          class="w-full p-4 border rounded-md border-[#333] text-[#333] cursor-pointer bg-[#FBFBFB]"
        >
          <a
            v-if="project.url"
            :href="project.url"
            target="_blank"
            class="h-full flex flex-col justify-between"
          >
            <div class="flex flex-col gap-y-3">
              <div class="w-full flex items-center justify-between">
                <div class="flex items-center gap-x-2">
                  <div>{{ index + 1 }}.</div>
                  <div
                    class="text-xs border border-[#333] px-2 py-1 w-max rounded-full"
                  >
                    {{ project.date }}
                  </div>
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  class="-rotate-45"
                >
                  <path
                    fill="none"
                    stroke="#333"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                    d="M4.5 12h15m0 0l-5.625-6m5.625 6l-5.625 6"
                  />
                </svg>
              </div>
              <div>
                <p class="font-bold text-[#F44F1A]">{{ project.title }}</p>
                <p class="mt-2 text-sm">{{ project.description }}</p>
              </div>
            </div>
            <div class="mt-4 flex gap-x-1 items-center">
              <img
                src="https://cdn-www.kompas.id/assets/img/icons/kompas-icon-small.svg"
                alt="logo Kompas"
              />
              <p class="text-xs font-bold">Associated with Harian Kompas</p>
            </div>
          </a>

          <div v-else class="h-full flex flex-col justify-between">
            <div class="flex flex-col gap-y-3 cursor-default">
              <div class="w-full flex items-center justify-between">
                <div class="flex items-center gap-x-2">
                  <div>{{ index + 1 }}.</div>
                  <div
                    class="text-xs border border-[#333] px-2 py-1 w-max rounded-full"
                  >
                    {{ project.date }}
                  </div>
                </div>
              </div>
              <div>
                <p class="font-bold text-[#F44F1A]">{{ project.title }}</p>
                <p class="mt-2 text-sm">{{ project.description }}</p>
              </div>
            </div>

            <div class="mt-4 flex gap-x-1 items-center">
              <img
                src="https://cdn-www.kompas.id/assets/img/icons/kompas-icon-small.svg"
                alt="logo Kompas"
              />
              <p class="text-xs font-bold">Associated with Harian Kompas</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div></div>
  </div>
</template>

<script setup>
import { ref } from "vue";

const dataProjects = ref([
  {
    title: "Menjelajah Jawa-Bali dengan Mobil Listrik",
    description:
      "An interactive website that displays travel information using an electric car from Jakarta to Bali. It includes data on power usage, charging points, tourist attractions, and other travel insights in an engaging visual format.",
    url: "https://interaktif.kompas.id/baca/liburan-mobil-listrik-jakarta-bali/",
    date: "Oct 2022",
  },
  {
    title: "Pesta Bola Qatar 2022",
    description:
      "A website providing exclusive updates from Qatar with rich reporting and data powered by Opta, including match schedules, scores, related articles, and statistics.",
    url: "https://pestabola.kompas.id",
    date: "Nov 2022",
  },
  {
    title: "Kompas x ICE BSD",
    description:
      "A landing page for the collaboration between Kompas and ICE BSD, showcasing event details and partnership content.",
    url: "https://icebsd.kompas.id",
    date: "Dec 2022",
  },
  {
    title: "Mengenal Permainan Tradisional Lewat Gim",
    description:
      "Introducing traditional Indonesian games through a digital experience. Features 4 playable games, each with point systems and cultural context.",
    url: "https://interaktif.kompas.id/baca/permainan-populer-anak-indonesia/",
    date: "Feb 2023",
  },
  {
    title: "Apa yang Anda Lakukan Saat Terjadi Gempa?",
    description:
      "An interactive website that educates users on earthquake preparedness with immersive content and guidance on what to do during seismic events.",
    url: "https://interaktif.kompas.id/baca/siap-siaga-hadapi-bencana-gempa/",
    date: "Apr 2023",
  },
  {
    title: "Seberapa Besar Pekerjaan Anda Terpapar Kecerdasan Artifisial?",
    description:
      "This project explores how generative AI impacts various professions. Users can interactively assess how much their job could be affected by artificial intelligence.",
    url: "https://interaktif.kompas.id/baca/kecerdasan-buatan-industri-kerja-dan-profesi/",
    date: "Jun 2023",
  },
  {
    title: "Jejak Kuliner Nusantara Presiden Soekarno",
    description:
      "Discover President Soekarno’s favorite Indonesian dishes through a playful interactive game that highlights his culinary preferences and national pride.",
    url: "https://interaktif.kompas.id/baca/masakan-nusantara-kemerdekaan/",
    date: "Jul 2023 - Aug 2023",
  },
  {
    title: "Mainkan Gim Sambut Asian Games",
    description:
      "To celebrate the Asian Games, this project features fun games designed to engage and excite users about the upcoming event.",
    url: "https://interaktif.kompas.id/baca/mainkan-gim-sambut-asian-games/",
    date: "Sep 2023",
  },
  {
    title: "Kenapa Anomali Iklim Pantik Prahara Beras?",
    description:
      "An in-depth explanation of how climate anomalies are affecting rice production in Indonesia, leading to price spikes and economic burden.",
    url: "https://interaktif.kompas.id/baca/produksi-beras-anomali-iklim-indonesia/",
    date: "Nov 2023 - Dec 2023",
  },
  {
    title: "Kenali Caleg dan Parpol Pilihanmu",
    description:
      "Discover detailed information about legislative candidates and political parties in the 2024 election. Make informed choices not just familiar ones.",
    url: "https://www.kompas.id/interaktif/ketahui-dapil-parpol-caleg-pilihanmu",
    date: "Jan 2024 - Feb 2024",
  },
  {
    title: "Cari Tahu Tahapan Pemilu agar Tak Ada Ragu",
    description:
      "Learn every step of the 2024 election process, from registration to voting day. Because voting isn’t just about casting a ballot it’s about knowing how it all works.",
    url: "https://www.kompas.id/interaktif/tentang-pemilu-indonesia",
    date: "Jan 2024 - Feb 2024",
  },
  {
    title: "Adu Gagasan Capres-cawapres, Siapa Unggul?",
    description:
      "Explore and compare the visions, missions, and programs of the 2024 presidential and vice-presidential candidates. Choose not just who's popular choose who's prepared.",
    url: "www.linkedin.com/in/muhammad-akmal-beliuk-168068223/details/projects/",
    date: "Jan 2024 - Feb 2024",
  },
  {
    title: "ICM (Interactive Content Management)",
    description:
      "An internal tool for managing Kompas.id article content—from creation to publication—streamlining editorial workflows with various functionalities.",
    url: "",
    date: "Feb 2024 - Apr 2025",
  },
]);
</script>

<style lang="scss" scoped></style>
